/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 */
import { type Theme, css } from '@emotion/react'

export const navigationControl = ({ colors }: Theme) => css`
  && .mapboxgl-ctrl-group {
    position: revert;
    background-color: ${colors?.backgroundLight};
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
    border-radius: 6px;

    &&:not(:empty) {
      box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
    }

    button {
      width: 32px;
      height: 32px;
    }
  }
`
